/*
 *             Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x4b0c=['ImportWord','pluginName'];(function(_0x37164a,_0x4b0cfe){var _0x958089=function(_0x52d4fe){while(--_0x52d4fe){_0x37164a['push'](_0x37164a['shift']());}};_0x958089(++_0x4b0cfe);}(_0x4b0c,0x14b));var _0x9580=function(_0x37164a,_0x4b0cfe){_0x37164a=_0x37164a-0x0;var _0x958089=_0x4b0c[_0x37164a];return _0x958089;};import{Plugin as _0x21e708}from'ckeditor5/src/core';import _0x4e7912 from'./importwordui';import _0x39011a from'./importwordediting';export default class i extends _0x21e708{static get[_0x9580('0x0')](){return _0x9580('0x1');}static get['requires'](){return[_0x39011a,_0x4e7912];}}